export default {
  title: 'Nuevo Perfil',
  title_edit: 'Editando Perfil'
}
